import React from 'react';
import { Row, Col } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import imageForm from '../../../../assets/images/misc/img-form.jpg';
import './styles.less';

const CheckList = () => {
  const items = [
    'Copia escritura pública de constitución de sociedad.',
    'Copia extracto y publicación en el Diario Oficial.',
    'Inscripción social con notas marginales y certificado de vigencia no superior a 60 días.',
    'Copia de modificaciones posteriores con sus respectivas inscripciones.',
    'Antecedentes legales según tipo de sociedad.',
    'Poderes',
    'Fotocopia de RUT de la sociedad',
    'Otros documentos.',
  ];

  return (
    <div className="checklist">
      <div style={{ padding: 20 }}>
        <p>
          <b>Recuerda tener a mano</b>
        </p>
        <ol className="checklist__ol">
          {items.map((item, index) => {
            const key = `item_${index}`;

            return (
              <li key={key}>
                <p>
                  <CheckOutlined className="checklist__check" />{' '}
                  <span className="checklist__item__text">{item}</span>
                </p>
              </li>
            );
          })}
        </ol>
      </div>
      <Row>
        <Col>
          <Row>
            <Col lg={10} xs={24}>
              <img className="checklist__img" src={imageForm} alt="imagen fondo" />
            </Col>
          </Row>
          <Row>
            <Col lg={15} xs={24} className="checklist__text">
              <p>En VanTrust queremos estar junto a ti para poder ofrecerte el mejor servicio.</p>
              <p>Si necesitas información contáctanos aquí.</p>
              <p className="checklist__text--contact">contacto@vantrust.cl</p>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default CheckList;
